import { AllyUserRole } from '@ally/transmitigator'

export const getDisplayRole = (allyUserRoles: AllyUserRole): string => {
  const { bank, creditcard, investment, mortgage } = allyUserRoles
  const roles = []

  if (bank) {
    roles.push('Bank')
  }
  if (investment) {
    roles.push('Invest')
  }
  if (creditcard) {
    roles.push('Credit Card')
  }
  if (mortgage) {
    roles.push('Home Loans')
  }

  return roles.join('/')
}
